/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * Utility for checking a value is JSON string.
 * @param {string | number | null} input The value to check.
 * @returns {boolean} Returns true if the value is proper JSON notation (not an array).
 */
export const isJson = (input: string | null): boolean => {
  try {
    if (typeof input !== 'string') {
      throw new Error('not a json string');
    }
    const parsed = JSON.parse(input);
    if (typeof parsed !== 'object' || parsed instanceof Array) {
      throw new Error('parsed value is not an object map');
    }

    return true;
  } catch (err) {
    return false;
  }
};
